// Глобальные компоненты
import MyCustomCheckbox from '@/components/globalCustomComponents/MyCustomCheckbox.vue';
import MyCustomSelect from '@/components/globalCustomComponents/MyCustomSelect.vue';
export default[
    MyCustomCheckbox,
    MyCustomSelect
]